import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';

export interface PostulacionNueva {
  id: number;
  candidatoId: number;
  candidatoNombres: string;
  requisicionId: number;
  requisicionCodigo?: string | null;
  cargoNombre?: string | null;
  createdAt: string;
}

export interface NuevasPostulacionesResponse {
  items: PostulacionNueva[];
  total: number;
}

/**
 * Alimenta el badge de "postulaciones nuevas" del toolbar (Fase A item #2).
 *
 * `nuevas()` devuelve las postulaciones que llegaron por el chat público
 * (fuente=chatbot_publico) y que el Analista GH aún no revisó.
 * `marcarRevisada()` las saca del contador.
 */
@Injectable({ providedIn: 'root' })
export class PostulacionesAlertasService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/postulaciones`;

  nuevas(): Observable<NuevasPostulacionesResponse> {
    return this.http.get<NuevasPostulacionesResponse>(`${this.base}/nuevas`);
  }

  marcarRevisada(id: number): Observable<void> {
    return this.http.put<void>(`${this.base}/${id}/marcar-revisada`, {});
  }
}
